import { newColors } from "constants/newColors";
import styled from "styled-components";

export const StyledWithMentionContainer = styled.div<{ isMyChat?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isMyChat }) => (isMyChat ? "end" : "start")};
  gap: 5px;
`;

export const StyledMentionedListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
`;

export const StyledMentionedSpan = styled.span`
  font-size: small;
  color: ${newColors.mention};
`;
